export type RecordFieldDataType = 'Text' | 'Multiline' | 'Date' | 'Phone' | 'Email' | 'Number';

export const RECORD_FIELD_TYPES: RecordFieldDataType[] = ['Text', 'Multiline', 'Date', 'Phone', 'Email', 'Number'];

// The primary-name field is the record's identifier (shown in lists, visits, and
// the {{RecordNames}} merge token), so it's limited to text-like types.
export const PRIMARY_RECORD_FIELD_TYPES: RecordFieldDataType[] = ['Text', 'Multiline'];

export interface RecordFieldDef {
  id: string;
  key: string;
  label: string;
  dataType: RecordFieldDataType;
  isRequired: boolean;
  isPrimaryName: boolean;
  sortOrder: number;
  isActive: boolean;
}

export interface RecordConfig {
  recordTypeId: string;
  singularLabel: string;
  pluralLabel: string;
  fields: RecordFieldDef[];
}

export interface CustomerRecord {
  id: string;
  customerId: string;
  primaryName: string;
  data: Record<string, string>;
  createdAtUtc: string;
  updatedAtUtc: string | null;
}
